/* eslint-disable no-unused-vars */
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import AuthModal from './AuthModal'; // Assuming this is your auth modal component
import useAuth from './useAuth';

export const withInactivityTimeout = (WrappedComponent) => {

  const WithTimeout = memo(({ ...props }) => {
    const { refreshTokenError, handleRefreshToken } = useAuth();
    const Token = localStorage.getItem('token');
    const inactiveTimerRef = useRef(null);
    // const navigate = useNavigate()
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
      return !!localStorage.getItem('token');
    });
    const [showAuthModal, setShowAuthModal] = useState(false);
    // const userTimeoutMinutes = 0.1667; // Pop will show after this time
    // const userTimeoutMinutes = 0.5; // Pop will show after this time
    // const userTimeoutMinutes = 0.5; // Pop will show after this time
    const userTimeoutMinutes = 20;

    useEffect(() => {
      // console.error('Error refreshing token: errrirr outer', refreshTokenError);
      if (refreshTokenError) {
        if (refreshTokenError.statusCode === 401) {
          localStorage.setItem('isHome', true);
          localStorage.removeItem('token');
          localStorage.removeItem('upid');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('expirationDate');
          localStorage.removeItem('userName');
          localStorage.removeItem('name');
          localStorage.removeItem('role');
          localStorage.removeItem('email');
          localStorage.removeItem('statusCode');
          localStorage.removeItem('message');
          localStorage.removeItem('userId');
          // navigate('/donorLogin')
        }
        console.error('Error refreshing token: ', refreshTokenError);
      }
    }, [refreshTokenError]);

    useEffect(() => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    }, []);

    const debouncedLogout = useCallback(() => {
      setShowAuthModal(true);
    }, []);


    const handleUserActivity = useCallback(() => {
      setShowAuthModal(false);
      clearTimeout(inactiveTimerRef.current);
      inactiveTimerRef.current = setTimeout(debouncedLogout, userTimeoutMinutes * 60 * 1000);
    }, [debouncedLogout, userTimeoutMinutes]);

    const handleAuthModalClose = useCallback(() => {
      setShowAuthModal(false);
      handleRefreshToken();
      handleUserActivity();
    }, [handleRefreshToken, handleUserActivity]);

    useEffect(() => {
      if (!isLoggedIn) return;
      const events = ['mousemove', 'keypress', 'click', 'scroll'];
      const eventListener = () => handleUserActivity();
      events.forEach((event) => window.addEventListener(event, eventListener));
      return () => {
        events.forEach((event) => window.removeEventListener(event, eventListener));
      };
    }, [handleUserActivity, isLoggedIn]);

    return (
      <>
        <WrappedComponent {...props} />
        {showAuthModal && Token && <AuthModal handleAuthModalClose={handleAuthModalClose} />}
      </>
    );
  });

  WithTimeout.displayName = `WithInactivityTimeout(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithTimeout;
};
